import React from "react";
import PageNavbarItem from "@insightfulscience/atomic-react/PageNavbar/Item";
import PageNavbarLink from "@insightfulscience/atomic-react/PageNavbar/Link";
import { string } from "prop-types";

export const LinkBlock = ({ linkText, linkUrl }) => (
	<PageNavbarItem>
		<PageNavbarLink href={linkUrl}>{linkText}</PageNavbarLink>
	</PageNavbarItem>
);

LinkBlock.propTypes = {
	linkText: string.isRequired,
	linkUrl: string.isRequired,
};
